import * as React from 'react'

import Loading from '@doordash/component-loading'

import { LoadingWrapper } from './styles'

export const StyledLoading: React.FC<{}> = () => {
  return (
    <LoadingWrapper>
      <Loading />
    </LoadingWrapper>
  )
}
